/**
 * Configuration au runtime pour les frontends (§7 bis.2).
 *
 * Les variables PUBLIC_/VITE_ sont figées au moment du build : on ne veut pas
 * une image par environnement. L'entrypoint du conteneur nginx écrit
 * /config.json à partir des variables d'environnement au démarrage ; le
 * frontend le lit ici. Une seule image, tous les environnements.
 */
import { chargerEnvPublic } from './env.js';
import { creerConstructeursUrl } from './urls.js';
export const CHEMIN_CONFIG_RUNTIME = '/config.json';
let cache;
/**
 * Charge et valide la configuration publique. Échoue bruyamment : un frontend
 * mal configuré doit s'arrêter, pas deviner une URL d'API.
 */
export async function chargerConfigNavigateur() {
    if (cache)
        return cache;
    const injectee = typeof window !== 'undefined' ? window.__ENV__ : undefined;
    let brute;
    if (injectee) {
        brute = injectee;
    }
    else {
        const reponse = await fetch(CHEMIN_CONFIG_RUNTIME, { cache: 'no-store' });
        if (!reponse.ok) {
            throw new Error(`Configuration runtime introuvable (${CHEMIN_CONFIG_RUNTIME} → ${reponse.status}). ` +
                "L'entrypoint du conteneur ne l'a pas générée.");
        }
        brute = (await reponse.json());
    }
    const env = chargerEnvPublic(brute);
    cache = { ...env, urls: creerConstructeursUrl(env) };
    return cache;
}
/** Réservé aux tests. */
export function reinitialiserConfigNavigateur() {
    cache = undefined;
}
//# sourceMappingURL=navigateur.js.map